// ------------------------------------------------------------------------------
// name: label
// author: mudas
// created: 2025/1/14
// ------------------------------------------------------------------------------

export enum ArtistLabelLevel {
  // 限制合作
  Restricting = '1', // 取值为 string，为后续可能扩展增加字母等元素预备

  // 高风险
  HighRisk = '2',

  // 中风险
  MediumRisk = '3',

  // 低风险
  LowRisk = '4',

  // 其他
  Other = '9',
}

export interface ArtistLabel {
  label: string;
  code: string;
  desc?: string;
  order?: number;

  // 风险等级（合作标签无此属性）
  tagLevel: ArtistLabelLevel;
}

export type CooperationLabel = Omit<ArtistLabel, 'tagLevel' | 'order'>;

export interface ArtistLabelSet {
  risk: ArtistLabel[];
  cooperation: CooperationLabel[];
}

export interface RiskTagsWithName {
  name: string;
  tags: ArtistLabel[];
}

export interface RiskTagUser {
  riskTag: {
    personal: RiskTagsWithName;
    enterprise?: RiskTagsWithName; // 企业标签可能不存在
  };
}

export interface CooperationTagUser {
  coopTag: CooperationLabel[];
}

export enum ArtistGroup {
  Art = 'ART', //美术创作者
  Ugc = 'UGC', //用户生成内容创作者
}
